import * as React from "react"

const Check = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M12 5.7L6.7 11 4 8.1l.8-.7 2 2.1L11.2 5l.7.7z" />
  </svg>
)

export default Check
